import React from 'react'
import BigBox from '../../components/ad_types/BigBox'
import zonePosts from './../../components/zone_posts/zonePosts'
import SidebarHeadlines from './../../components/headlines/sidebar/SidebarHeadlines'

export default function Sidebar({ league = '' }) {
    const Headlines = zonePosts(league, 'headlines')(SidebarHeadlines)
    const uppercaseLeagueStr = league.toUpperCase()

    return (
        <React.Fragment>
            <BigBox bg={false} view="all" visible={true} refresh={false} />
            {/*<div>
                <div className="broadcastinfo trade-deadline">
                    <a href="https://watch.sportsnet.ca/event/FREE_ON_SN_NOW_Hockey_Central_Trade_Deadline_64819">
                        <img src={`${env_url}/NHL_TD_SN_2022.jpeg`} />
                    </a>
                    <div>
                        Stream our live coverage of Deadline Day on{' '}
                        <a href="https://watch.sportsnet.ca/event/FREE_ON_SN_NOW_Hockey_Central_Trade_Deadline_64819">
                            Sportsnet NOW
                        </a>
                        !
                    </div>
                </div>
            </div>*/}
            <Headlines postHeader={uppercaseLeagueStr} />
        </React.Fragment>
    )
}
